import { useMenuButton } from "../useMenuButton";
import { Button } from "@tickchak/react-share/app";
import { pen, remove } from "../../../../../../../assets/symbols/symbols/Symbols.css";
import * as css from '../../PricingStep/PricingStep.css';
import { PriceGroup } from "../../../../../../../redux/subscription/subscription.type";
import { formatDecimal } from "../../../../../../../library/numberFunction";

interface PriceGroupButtonWithMenuProps {
    priceGroup: PriceGroup;
    onEdit: (e: React.MouseEvent, priceGroup: PriceGroup) => void;
    onDelete: (priceGroupId: number) => void;
    t: (key: string) => string;
}

function PriceGroupButtonWithMenu({priceGroup, onEdit, onDelete, t}: PriceGroupButtonWithMenuProps) {
    const menuOptions = [
        {text: t('editPriceGroup'), onClick: () => {
            const mockEvent = {stopPropagation: () => {}} as React.MouseEvent;
            onEdit(mockEvent, priceGroup);
        }, icon: pen, dataCyName: 'edit'},
        {text: t('delete'), onClick: () => onDelete(priceGroup.spgId), icon: remove, dataCyName: 'delete'}
    ];

    const {menuIcon, menuList} = useMenuButton(menuOptions);

    return (
        <css.priceGroupButton>
            <Button
                data-cy={`subscription-price-group-${priceGroup.spgId}-btn`}
                variant="neutral"
                size="category"
                iconEnd={menuIcon}
            >
                {priceGroup.title} ({formatDecimal(priceGroup.minPrice)}-{formatDecimal(priceGroup.maxPrice)}₪)
            </Button>
            {menuList}
        </css.priceGroupButton>
    );
}
export default PriceGroupButtonWithMenu;